module.exports = require("http");


//////////////////
// WEBPACK FOOTER
// external "http"
// module id = 80
// module chunks = 0